import client from './client';

export const automationsApi = {
  list: (params) => client.get('/automations', { params }).then((r) => r.data),
  get: (id) => client.get(`/automations/${id}`).then((r) => r.data),
  create: (payload) => client.post('/automations', payload).then((r) => r.data),
  update: (id, payload) => client.put(`/automations/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/automations/${id}`).then((r) => r.data),
  // Run this automation now (optionally for a specific YYYY-MM period).
  run: (id, payload = {}) => client.post(`/automations/${id}/run`, payload).then((r) => r.data),
  // Pause / resume.
  setStatus: (id, status) => client.patch(`/automations/${id}/status`, { status }).then((r) => r.data),
  // Approve / reject a pending run from inside the app.
  decideRun: (id, runId, decision) =>
    client.post(`/automations/${id}/runs/${runId}/decision`, { decision }).then((r) => r.data),
  // Dashboard: stats + metrics + posts for one automation.
  dashboard: (id) => client.get(`/automations/${id}/dashboard`).then((r) => r.data),
  // Stop generating new posts.
  stop: (id) => client.post(`/automations/${id}/stop`).then((r) => r.data),
  // Hold / release all of this automation's scheduled posts.
  setPostings: (id, paused) => client.post(`/automations/${id}/postings`, { paused }).then((r) => r.data),

  /* --- RSS automations --- */
  // Check a feed URL and preview its newest articles (no automation needed yet).
  validateFeed: (url, limit = 10) =>
    client.post('/rss/validate', { url, limit }).then((r) => r.data),
  // The automation's article queue, its per-status counts and feed health.
  feedItems: (id) => client.get(`/automations/${id}/feed-items`).then((r) => r.data),
  // Drop an article from the queue (kept as a dedup record so it can't return).
  removeFeedItem: (id, itemId) =>
    client.delete(`/automations/${id}/feed-items/${itemId}`).then((r) => r.data),
  // Poll the feed right now instead of waiting for the next scheduled check.
  fetchNow: (id) => client.post(`/automations/${id}/fetch-now`).then((r) => r.data),
};

export default automationsApi;
